module.exports = "<ul id=countdown count-down-timer=$ctrl.time class=countdown> {{$ctrl.time}} <li> <span class=hours></span> </li> <li> <span class=minutes></span> </li> <li> <span class=seconds></span> </li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./src/components/count-down-timer/count-down-timer.template.html
// module id = 86
// module chunks = 0